import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { PropertyType } from 'src/app/models/enums/property-type';
import { AttributeDefinition } from 'src/app/models/server/attribute-definition';
import { Folder } from 'src/app/models/server/folder';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'avmAttributeFieldPipe',
    standalone: true,
    pure: true,
})
export class AvmAttributeFieldPipe implements PipeTransform {
    constructor() {}

    /**
     * Formate la valeur d'un champ d'un attribut de dossier.
     * @param folder : Instance du dossier dont l'attribut est affiché dans le champ.
     * @param columnDefinition : Définition de l'attribut affiché par le champ
     */
    transform(folder: Folder, attributeDefinition: AttributeDefinition): string {
        //console.count(`AvmAttributeFieldPipe - transform ${folder.id} - ${attributeDefinition.header}`);

        if (attributeDefinition.custom) {
            const renderedValue = folder.customAttributes[attributeDefinition.propertyCode];

            if (renderedValue) {
                return renderedValue;
            } else {
                return '';
            }
        } else {
            if (attributeDefinition.type === PropertyType.List || attributeDefinition.type === PropertyType.ListCustomers || attributeDefinition.type === PropertyType.ListUsers) {
                const value = folder[attributeDefinition.propertyCode];

                if (value) {
                    // Retourne l'id de la valeur selectionnée au format string
                    return `${value}`;
                } else {
                    return null;
                }
            } else {
                const renderedValue = folder[attributeDefinition.propertyCode];

                if (renderedValue) {
                    return renderedValue;
                } else {
                    return '';
                }
            }
        }
    }
}
